import services from '@/commons/services';
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        list: [],
        scriptStubs: {},
        llmNotionConfigs: [],

    },
    mutations: {
        setList(state, list) {
            state.list = list;
        },
        setScriptStubs(state, list) {
            state.scriptStubs = _.keyBy(list, 'id');
        },
        updateState(state, params) {
            if (Array.isArray(params)) {
                params.forEach(par => {
                    _.set(state, par.path, par.data);
                })
            } else {
                if (params.path) {
                    _.set(state, params.path, params.data);
                } else {
                    state[params.var] = params.data;
                }
            }
        },
    },
    actions: {
        getLlms({commit}, params = {}) {
            let request = _.merge({
                count: 100,
                order: [{field: 'name', orderType: 'ASC'}],
                needFields: ['name', 'description', 'contextSize', 'script', 'templates']
            }, params.request);
            return services.llm_completion.scripts(request).prepare(params.prepare).then(resp => {
                commit('setList', resp.data.list)
                return resp.data;
            });
        },
        saveLlm(context, params = {}) {
            return services.llm_completion.saveLlm(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        deleteLlm(context, params = {}) {
            return services.llm_completion.deleteLlm(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        testLlm(context, params = {}) {
            return services.llm_completion.testScript(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        getScriptStubs({commit}, params = {}) {
            return services.llm_completion.scriptStubs({count: 1000}).prepare(params.prepare).then(resp => {
                commit('setScriptStubs', resp.data.list)
                return resp.data;
            });
        },
        getScriptStubContent(context, params = {}) {
            return services.llm_completion.scriptStubs({
                filter: {ids: [params.request]},
                count: 1,
                needContent: true
            }).prepare(params.prepare).then(resp => {
                return resp.data.list[0]?.content;
            });
        },
        // Templates
        getTemplates(context, params = {}) {
            let request = _.merge({
                count: 100,
                order: [{field: 'alias', orderType: 'ASC'}]
            }, params.request);
            return services.llm_completion.templates(request).prepare(params.prepare).then(resp => {
                return resp.data;
            });
        },
        getSSTemplates(context, params = {}) {
            let request = _.merge({
                count: 100,
                offset: 0,
            }, params.request);
            return services.smartsearch_template.list(request).prepare(params.prepare).then(resp => {
                return resp.data;
            });
        },
        saveTemplate(context, params = {}) {
            return services.llm_completion.saveTemplate(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        deleteTemplate(context, params = {}) {
            return services.llm_completion.deleteTemplate(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        testTemplate(context, params = {}) {
            return services.llm_completion.testTemplate(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        getTemplateParameters(context, params = {}) {
            return services.llm_completion.templateParameters(params.request).prepare(params.prepare).then(resp => resp.data);
        },
        getLlmNotionConfigs(ctx, params = {}) {
            let request = {
                "filter": {},
                "offset": 0,
                "count": 100,
                "order": [
                    {field: 'name', type: 'ASC'}
                ]
            }
            return services.notionAssistant.configs(request).prepare(params.prepare).then(resp => {
                ctx.commit('updateState', {
                    path: 'llmNotionConfigs',
                    data: resp.data.list
                });

                return resp.data;
            });
        },
        saveConfig(ctx, query) {
            return services.notionAssistant.saveConfig(query).then(resp => {
                console.log('Saved:::', resp.data)
                let llmConfigs = ctx.state.llmNotionConfigs;
                let idx = query.id ? llmConfigs.findIndex(it => it.id === query.id) : 0,
                    del = query.id ? 1 : 0;
                llmConfigs.splice(idx, del, resp.data)
                llmConfigs = _.orderBy(llmConfigs, 'name', 'asc');
                ctx.commit('updateState', [{
                    path: 'llmNotionConfigs',
                    data: llmConfigs
                }])
                return resp.data;
            });
        },
        deleteConfig(ctx, id) {
            return services.notionAssistant.deleteConfig({ids:[id]}).then(resp => {
                console.log('Deleted:', resp.data)
                ctx.commit('updateState', [{
                    path: 'llmNotionConfigs',
                    data: ctx.state.llmNotionConfigs.filter(it => it.id !== id)
                }])
                return resp.data;
            });
        }

    }
};

